/**
 * מזהי supplement בקטלוג LDS — אחרי xmltodict / JSON מהשרת.
 * ה-XML ל-order משחזר <id> מתוך תוצאת החיפוש; חייב להתאים למה ש-LDS מכיר.
 *
 * סדר המועמדים חייב להישאר מסונכרן עם
 * `HotelsRiver_BE-main_whist/services/lds_supplement_shape_debug._resolve_catalog_id_preview`.
 */

function unwrapXmltodictScalar(v) {
  if (v == null || v === "") return null;
  if (typeof v === "number" && Number.isFinite(v)) return String(v);
  if (typeof v === "string") return v.trim() || null;
  if (typeof v === "object" && v !== null && "#text" in v) {
    const t = v["#text"];
    if (t == null || t === "") return null;
    return String(t).trim() || null;
  }
  return null;
}

/**
 * @param {Record<string, unknown>|null|undefined} item — איבר supplement גולמי מתוך deal.supplement
 * @returns {string|null}
 */
export function getLdsSupplementCatalogIdOrNull(item) {
  if (!item || typeof item !== "object") return null;
  const candidates = [
    item.id,
    item.ID,
    item["@id"],
    item["@seqNum"],
    item.seqNum,
    item.supplementId,
    item.SupplementId,
  ];
  for (const c of candidates) {
    const s = unwrapXmltodictScalar(c);
    if (s != null) return s;
  }
  return null;
}

/**
 * @param {Record<string, unknown>} item
 * @param {string} [hint]
 * @returns {string}
 */
export function requireLdsSupplementCatalogId(item, hint = "") {
  const id = getLdsSupplementCatalogIdOrNull(item);
  if (id != null) return id;
  const keys =
    item && typeof item === "object" ? Object.keys(item).slice(0, 25).join(", ") : "";
  throw new Error(
    `LDS supplement חסר מזהה קטלוג (id / @id / @seqNum). ${hint} מפתחות בשורה: ${keys || "(ריק)"}`
  );
}
